import { render, staticRenderFns } from "./ViewEmailItemPage.vue?vue&type=template&id=ae038ec8&scoped=true&"
import script from "./ViewEmailItemPage.vue?vue&type=script&lang=js&"
export * from "./ViewEmailItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewEmailItemPage.vue?vue&type=style&index=0&id=ae038ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae038ec8",
  null
  
)

export default component.exports